/**
 * Normalize a string into a tag id
 * This function takes a string input and normalizes it into a tag id by applying the following transformations:
 */
export const normalizeToId = (s: string) => {
  if (!s) return "";
  let id = s.toLowerCase();

  // replace spaces and underscores with hyphens
  id = id.replace(/[_\s]+/g, "-");
  // remove anything that's not a-z, 0-9 or hyphen
  id = id.replace(/[^a-z0-9-]/g, "");
  // collapse multiple hyphens
  id = id.replace(/-+/g, "-");
  // trim hyphens
  id = id.replace(/^-|-$/g, "");
  return id;
};
